import digitalData from 'digital-data';
import {
  OVERLAY
} from '../constants';

export const viewSimilar = () => {
  // 6.1 View Similar Items
  LIFE_CYCLE_EVENT_BUS.on('view-similar.morelikethisoverlay', () => {
      const ddoEvent = { 
        category: {
          primaryCategory: OVERLAY
        },
        eventInfo: {
          eventName: 'view similar items recommendation'
        }
      };
  
      digitalData.event = digitalData.event || [];
      digitalData.event.push(ddoEvent);
    });
};
